import { track } from "../track";

export const trackAvatarCreateClick = () => track({ event: "avatar_create_click" });
